import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import moment from "moment";
import {
  flipRange,
  canShowRangeSwitch,
  onFetchOdo,
  changeVehicle,
} from "./historyReport/historyReport";
import { combineIdlingAlarms } from "./advancedFuelReport/AdvancedFuelReportWidget";

let _dateFormat = dateFormat + ":ss";

const processData = (respObj, vehicleMap, callback) => {
  let alarmTypes = {};
  window.alarmTypes = {};
  let locationbodyfrom = [];
  let historyData = [];

  for (let vehicleid in respObj) {
    if (!vehicleMap[vehicleid]) continue;

    let vehicleno = vehicleMap[vehicleid].vehicleno;
    let alarmtype;
    for (let category in respObj[vehicleid]) {
      let alarmList = respObj[vehicleid][category];
      alarmList = combineIdlingAlarms(alarmList, true);
      for (let idx in alarmList) {
        let alarmtime = moment(parseInt(alarmList[idx].time, 10)).format(
          "DD-MMM-YYYY HH:mm:ss"
        );
        let alarmtimestamp = parseInt(alarmList[idx].time, 10);
        let speed =
          alarmList[idx].speed != null
            ? parseFloat(alarmList[idx].speed.toFixed(2))
            : 0;
        let latlng = "-";
        let latLngArr = [];
        if (alarmList[idx].lat && alarmList[idx].lng) {
          latlng =
            alarmList[idx].lat.toFixed(6) + "," + alarmList[idx].lng.toFixed(6);
          latLngArr = [
            alarmList[idx].lat.toFixed(6),
            alarmList[idx].lng.toFixed(6),
          ];
        }
        let severity = alarmList[idx].severity || "Medium";
        let duration = alarmList[idx].duration;
        if (
          duration &&
          duration % 1 != 0 &&
          alarmList[idx].alarmtype !== "Long Idling"
        )
          duration = duration.toFixed(2);

        if (category === "dtc") {
          for (let dtcidx in alarmList[idx].dtcs) {
            alarmtype =
              alarmList[idx].dtcs[dtcidx].desc +
              "(" +
              alarmList[idx].dtcs[dtcidx].code +
              ")";
            locationbodyfrom.push([alarmList[idx].lat, alarmList[idx].lng]);
            historyData.push({
              vehicleno,
              alarmtime,
              alarmtimestamp,
              category,
              alarmtype,
              speed,
              latlng,
              latLngArr,
              severity,
              duration,
            });
            alarmtype = alarmtype.replace("_RESOLVED", "");
            alarmTypes[alarmtype] = true;
          }
        } else if (category !== "userscore") {
          locationbodyfrom.push([alarmList[idx].lat, alarmList[idx].lng]);
          alarmtype = alarmList[idx].alarmtype;
          historyData.push({
            vehicleno,
            alarmtime,
            alarmtimestamp,
            category,
            alarmtype,
            speed,
            latlng,
            latLngArr,
            severity,
            duration,
          });
          alarmtype = alarmtype.replace("_RESOLVED", "");
          alarmTypes[alarmtype] = true;
        }
      }
    }

    window.alarmTypes = { ...window.alarmTypes, ...alarmTypes };
  }

  callback(historyData);
};

const setAlarmTypes = (widget, alarmTypes) => {
  let data = [];
  let counter = 0;
  for (let idx in alarmTypes) {
    if (alarmTypes[idx]) {
      counter++;
      data.push({
        name: idx,
        id: counter,
      });
    }
  }
  widget.setData({ dataid: Date.now(), data, name: "name", id: "id" }, true);
  widget.setItemByIds(
    data.map((i) => {
      return i.id;
    })
  );
  widget.setInputValue("");
};

class AlarmReport {
  constructor() {
    this.finalData = null;
    this.newData = [];
    this.schema = this.createSchema();
  }

  filterAndSetData = () => {
    const schema = this.schema;
    let data = this.finalData;
    let selectedItems = schema.toolbar[4].ref.getData();
    if (selectedItems) {
      data = data.filter((i) => {
        let matched;
        for (let idx in selectedItems) {
          if (
            i.alarmtype &&
            i.alarmtype.indexOf(selectedItems[idx].name) !== -1
          ) {
            matched = true;
            break;
          }
        }
        return matched;
      });
      if (schema.content[0].ref) {
        schema.content[0].ref.setData(data);
      }
    }
  };

  getHistory = (schema, data, store) => {
    this.finalData = null;
    let saveState = null;
    let tableStateData = null;
    window.alarmTypes = {};

    if (!data.vehicle.length) {
      store.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "Please select a vehicle",
          content: "Please select a vehicle",
          createAt: Date.now(),
          autoClose: 8000,
          showError:true
        },
      });
      return;
    }

    let starttime = data.starttime.unix() * 1000;
    let endtime = data.endtime.unix() * 1000;

    if (starttime > endtime) {
      store.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "Start time should be less than the end time",
          content: "Start time should be less than the end time",
          createAt: Date.now(),
          autoClose: 8000,
          showError:true
        },
      });
      return;
    }

    if (endtime - starttime > 1000 * 60 * 60 * 24 * 31) {
      store.dispatch({
        type: "ADD_INTOAST",
        data: {
          name: "You can't select a date range of more than 31 days",
          content: "You can't select date range of more than 31 days",
          createAt: Date.now(),
          autoClose: 8000,
          showError:true
        },
      });
      return;
    }

    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(this.schema, true);

    if (data.vehicle && data.vehicle.length) {
      const handleSuccess = (resp) => {
        window.dataForAll = resp;
        if (window.setReportWindowTabBusy)
          window.setReportWindowTabBusy(this.schema, false);
        processData(resp, store.vehicleMap, (data) => {
          this.finalData = data;
          if (tableStateData && tableStateData[0]) {
            tableStateData[0].body = data;
            tableStateData[0].busy = false;
            saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
          }
          setAlarmTypes(schema.toolbar[4].ref, window.alarmTypes);
          this.filterAndSetData();
        });
        let heads = this.schema.content[0].head;
        this.newData = [];
        for (let idx in this.finalData) {
          let tempdata = {};
          for (let rdx in heads) {
            if (heads[rdx].key in this.finalData[idx]) {
              let key = heads[rdx].key;
              let name = heads[rdx].name;
              tempdata[name] = this.finalData[idx][key];
            }
          }
          this.newData.push(tempdata);
        }
      };

      if (schema.content[0].ref) {
        schema.content[0].ref.setBusy(true);
        saveState = schema.content[0].ref.props.saveState;
        tableStateData = [
          schema.content[0].ref.state,
          schema.content[0].ref.props.schemaKey,
          schema.content[0].ref.props.data,
        ];
      }

      let body = {
        vehicleid: data.vehicle.map((item) => {
          return item.data.vehicleid;
        }),
        starttime: data.starttime.unix() * 1000,
        endtime: data.endtime.unix() * 1000,
        filter: true,
        allalarms: 1,
      };

      if (window.showNoGpsFixData === true) {
        body.fixqfilter = false;
      }

      ReportAPIs.getAlarmHistory(body).then(handleSuccess, (r) => {
        handleSuccess({});
      });
    } else {
      window.graphDataErr = "";
      window.dataForAll = null;
      window.graphDataErr = "Please Select Vehicle";

      if (window.InMapForceUpdate) {
        window.InMapForceUpdate();
      }
      if (window.InGraphControlForceUpdate) {
        window.InGraphControlForceUpdate();
      }

      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(this.schema, false);
      return;
    }
  };

  createSchema() {
    const boundFlipRange = flipRange.call(this, (report) => {
      report.schema.toolbar[5].onClick = report.odometerRange
        ? onFetchOdo(this.getHistory)
        : this.getHistory;
    });

    return {
      key: "alarm_report",
      name: "Alarms",
      toolbar: [
        {
          key: "vehicle",
          type: schemaTypes.MULTI_SELECT,
          storeData: (state) => {
            return {
              data: (() => {
                let newMap = {};
                for (let idx in state.vehicleMap) {
                  if (idx.indexOf("user") === -1) {
                    newMap[idx] = state.vehicleMap[idx];
                  }
                }
                return newMap;
              })(),
              name: "vehicleno",
              id: "vehicleid",
            };
          },
          onItemChange: changeVehicle.bind(this),
          defaultValue: () => {
            return {
              data: window.selectedVehicles.map((i) => {
                return i.id;
              }),
              updatedAt: window.selectedVehiclesUpdatedAt,
            };
          },
        },
        {
          key: "switch",
          type: schemaTypes.BUTTON,
          iconType: "class",
          icon: "fa fa-exchange",
          onClick: boundFlipRange,
          tooltip: "Switch between date range and odometer",
          isShowable: canShowRangeSwitch,
        },
        {
          key: "starttime",
          type: schemaTypes.DATE_PICKER,
          setIfNull: true,
          placeholder: "Start Date",
          model: Date.now() - 1000 * 60 * 60 * 24,
        },
        {
          key: "endtime",
          type: schemaTypes.DATE_PICKER,
          setIfNull: true,
          placeholder: "End Date",
        },
        {
          key: "filter",
          type: schemaTypes.MULTI_SELECT,
          placeholder: "Filter By Alarm",
          onItemChange: () => {
            setTimeout(() => this.filterAndSetData(), 100);
          },
        },
        {
          key: "get_history",
          type: schemaTypes.BUTTON,
          name: "Get Alarm Report",
          onClick: this.getHistory,
        },
        {
          key: "download",
          type: schemaTypes.BUTTON,
          iconType: "class",
          icon: "fa fa-download",
          onClick: () => {
            if (this.finalData) {
              setTimeout(() => {
                JSONToCSVConvertor(this.newData, "ViewReport", false);
              }, 500);
            }
          },
        },
      ],
      content: [
        {
          key: "dataTable",
          type: schemaTypes.IN_TABLE,
          position: {
            width: 12,
            height: 12,
            left: 0,
            top: 0,
          },
          head: [
            { key: "vehicleno", name: "Vehicle No" },
            {
              key: "alarmtime",
              name: "Alarm Time",
              timestamp: "alarmtimestamp",
            },
            { key: "category", name: "Alarm Category", width: 1.3 },
            { key: "alarmtype", name: "Alarm Name" },
            { key: "speed", name: "Speed (Kmph)" },
            {
              key: "latlng",
              name: "Lat Lng",
              width: 1.4,
              onClick: (d, item) => {
                window.showInGoogleMaps(item.latLngArr[0], item.latLngArr[1]);
              },
            },
          ],
        },
      ],
    };
  }
}

const alarmReport = new AlarmReport();
export default alarmReport.schema;
